import { PaymentMethodType } from '@one/types/dist/orderpath/app/shared'

export default function usePaymentsUtils(vm) {
  const simplePayLogo = 'https://static-demo-images.s3-eu-west-1.amazonaws.com/simplepay_w140.png'
  const payNowLogo = require('@/assets/logos/paynow.png')
  const imojeLogo = require('@/assets/logos/iMoje.png')
  const przelewy24logo = require('@/assets/logos/przelewy24.png')
  const leaselinkLogo = require('@/assets/logos/leaselink.svg')
  const stripeLogo = require('@/assets/logos/stripe.png')

  const simplePayBankCardsLogos = 'https://static.onecommerce.shop/cms/15e27c5c265e44d7a0dbe749153f197b-simplepay-logo-uj-2023-1-.png'

  const simplePayInformationHu = 'http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf'
  const simplePayInformationEng = 'http://simplepartner.hu/PaymentService/Payment_information.pdf'

  const getSimplePayInformationLink = (lang: string) => {
    return lang === 'hu' ? simplePayInformationHu : simplePayInformationEng
  }

  const showIcons = (element: PaymentMethodType): string => {
    switch (element) {
      case PaymentMethodType.TRADE_CREDIT:
        return 'icon-ecommerce-wallet'
      case PaymentMethodType.CASH_ON_DELIVERY:
        return 'icon-ecommerce-banknote'
      case PaymentMethodType.PREPAID:
        return 'icon-ecommerce-creditcard'
      case PaymentMethodType.PRZELEWY24:
        return 'icon-ecommerce-banknotes'
      default:
        return 'icon-ecommerce-wallet'
      }
    }

  const paymentsLogos = (type: PaymentMethodType): any => {
    switch (type) {
      case PaymentMethodType.SIMPLEPAY:
        return {
          img: simplePayLogo,
          alt: vm.$t('cart.simplepay_image'),
          isLogo: true,
        }
      case PaymentMethodType.PAYNOW:
        return { img: payNowLogo, alt: 'PayNow', isLogo: true }
      case PaymentMethodType.IMOJE:
        return { img: imojeLogo, alt: 'Imoje', isLogo: true }
      case PaymentMethodType.PRZELEWY24:
        return { img: przelewy24logo, alt: 'Przelewy24', isLogo: true }
      case PaymentMethodType.STRIPE:
        return { img: stripeLogo, alt: 'Stripe', isLogo: true }
      case PaymentMethodType.LEASELINK:
        return { img: leaselinkLogo, alt: 'Leaselink', isLogo: true }
      default:
        return { img: '', alt: '', isLogo: false }
    }
  }

  return {
    simplePayLogo,
    payNowLogo,
    imojeLogo,
    przelewy24logo,
    leaselinkLogo,
    simplePayBankCardsLogos,
    simplePayInformationHu,
    simplePayInformationEng,
    getSimplePayInformationLink,
    showIcons,
    paymentsLogos,
  }
}
